import { render, staticRenderFns } from "./CommonBottom.vue?vue&type=template&id=9140a1a6&"
import script from "./CommonBottom.vue?vue&type=script&lang=js&"
export * from "./CommonBottom.vue?vue&type=script&lang=js&"
import style0 from "./CommonBottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports